import { c as _c } from "react/compiler-runtime";
import type { Provider } from '@newfront-insurance/react-provision';
import { useProvider } from '@newfront-insurance/react-provision';
import { type ReactNode, type JSX } from 'react';
import * as React from 'react';
import type { AuthProviderProps } from '../providers/auth-provider';
import { useAuthClientLogin } from '../providers/auth-provider';
import type { AuthProviderContext } from '../types';
type Props = LoginBoundaryProps & {
  // eslint-disable-next-line react/no-unused-prop-types
  CustomLoginBoundary?: React.ComponentType<LoginBoundaryProps>;
};
export type LoginBoundaryProps = {
  fallback?: JSX.Element | null;
  children: ReactNode;
  authProvider: Provider<AuthProviderContext, AuthProviderProps>;
  // eslint-disable-next-line react/no-unused-prop-types
  isEnabled?: boolean;
};
export function LoginBoundary(t0) {
  const $ = _c(9);
  let restProps;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      isEnabled: t1,
      CustomLoginBoundary: t2,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = restProps;
    $[2] = t1;
    $[3] = t2;
  } else {
    restProps = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const isEnabled = t1 === undefined ? true : t1;
  const CustomLoginBoundary = t2 === undefined ? undefined : t2;
  if (!isEnabled) {
    return restProps.children as JSX.Element;
  }
  if (CustomLoginBoundary) {
    let t3;
    if ($[4] !== CustomLoginBoundary || $[5] !== restProps) {
      t3 = <CustomLoginBoundary {...restProps} />;
      $[4] = CustomLoginBoundary;
      $[5] = restProps;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t3;
  if ($[7] !== restProps) {
    t3 = <LoginBoundaryProvider {...restProps} />;
    $[7] = restProps;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}

/**
 * Everything within this boundary will only be rendered if the user has completed the auth flow.
 */
export function LoginBoundaryProvider(props) {
  const {
    fallback,
    children,
    authProvider
  } = props;
  const {
    authState,
    client
  } = useProvider(authProvider);
  const {
    isLoggedIn,
    isReady
  } = authState;
  useAuthClientLogin(client);
  if (!isReady || !isLoggedIn) {
    return fallback || null;
  }
  return children as JSX.Element;
}